/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import styled from 'styled-components';

import _Picture from 'shared/components/presentational/Picture';
import pxInRem from 'shared/helpers/styled-components/remHelper';
import { FONT_FAMILIES } from 'shared/constants/theme';

const Wrapper = styled.div`
  background-color: ${props => props.theme.tvGuide.channel.background};
  display: flex;
  align-items: center;
  padding-top: 10px;
  flex-direction: column;
  justify-content: space-evenly;
  width: 100%;
`;

const Picture = styled(_Picture)`
  display: flex;
  width: 60px;
  height: 45px;
`;

const Title = styled.p`
  font-size: ${pxInRem('12px')};
  font-family: ${FONT_FAMILIES.base};
  display: flex;
  justify-content: center;
  margin: 0;
`;

const Details = styled.div``;

// eslint-disable-next-line react/prefer-stateless-function
export default class Channel extends React.PureComponent {
  displayName = 'Channel';

  render() {
    const { imageUrl, zapNumber, className } = this.props;
    return (
      <Wrapper className={className}>
        <Title>{zapNumber}</Title>
        <div>
          <Picture url={imageUrl} width={60} height={45} />
        </div>
        <Details>&nbsp;</Details>
      </Wrapper>
    );
  }
}
